import React from "react";
import ReactDOM from "react-dom";
import { Map } from "./map";
import { Filters } from "./filters";
import { mapboxMap } from "./mapbox";
import { Provider } from "unistore/react";
import { store } from "./store";
import "./styles.css";

const myMap = new mapboxMap();

class App extends React.Component {
  render() {
    return (
      <Provider store={store}>
        <div className="container">
          <Filters />
          <Map map={myMap} />
        </div>
      </Provider>
    );
  }
}

ReactDOM.render(<App />, document.getElementById("root"));
